





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "statistic",
        components: {},
        mixins:[]
    })
    export default class statistic extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
